import { render, staticRenderFns } from "./YueDuTianKong.vue?vue&type=template&id=0cf3c5df&scoped=true"
import script from "./YueDuTianKong.vue?vue&type=script&lang=js"
export * from "./YueDuTianKong.vue?vue&type=script&lang=js"
import style0 from "./YueDuTianKong.vue?vue&type=style&index=0&id=0cf3c5df&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf3c5df",
  null
  
)

export default component.exports